/* eslint-disable react/jsx-no-undef */
import { Container, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PaperHeaderButton } from "../../_components/button/paperHeader.button";
import { PaperTableHeader } from "../../_components/table/header.table";
import { API_URL } from "../../_config/config.const";
import { TelerikReportViewer } from '@progress/telerik-react-report-viewer/dist/cjs/main';
import { useEffect, useState } from "react";
import { PageHeader } from "../../_components/header/page.header";
import { accountService } from "../../_services/accounts.service";
import { useContainerStyles } from "../../_styles/container.styles";

export function DashboardIndex() {

    let navigate = useNavigate();
    let viewer: any;

    const [styles, setStyles] = useState({
        position: 'absolute',
        left: '14.5%',
        right: '2%',
        top: '16%',
        bottom: '1%',
        overflow: 'hidden',
        clear: 'both',
        fontFamily: 'ms sans serif'
    })

    return (
        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="Dashboard"
                />
                <Paper>

                    {/* <TelerikReportViewer*/}
                    {/*    ref={(el: any) => viewer = el}*/}
                    {/*    serviceUrl={`${API_URL}/report/`}*/}
                    {/*    reportSource={{*/}
                    {/*        report: 'App.Reporting.Dashboard.Dashboard, App.Reporting',*/}
                    {/*    }}*/}
                    {/*    viewerContainerStyle={styles}*/}
                    {/*    viewMode="INTERACTIVE"*/}
                    {/*    scaleMode="FIT_PAGE_WIDTH"*/}
                    {/*    enableAccessibility={false}*/}
                    {/*    pageMode="CONTINUOUS_SCROLL"*/}
                    {/*    parametersAreaVisible={true}*/}
                    {/*    parametersAreaPosition="RIGHT"*/}
                    {/*    renderingEnd*/}
                    {/*/> */}
                </Paper>
            </div>

        </>

        //<>

        //    <button id="refresh-button" onClick={() => viewer.refreshReport()}>Refresh</button>
        //    <button onClick={() => viewer.commands.print.exec()}>Print</button>
        //</>
    );
}